export enum EHubLocationAlias {
  MA_ANDOVER = 'MA_ANDOVER',
  NJ_TETERBORO = 'NJ_TETERBORO',
  NJ_NEW_YORK = 'NJ_NEW_YORK',
  NC_DURHAM = 'NC_DURHAM',
  GA_ATLANTA = 'GA_ATLANTA',
  GA_SANDY_SPRINGS = 'GA_SANDY_SPRINGS',
  FL_TAMPA = 'FL_TAMPA',
  TX_HOUSTON = 'TX_HOUSTON',
  TX_DALLAS = 'TX_DALLAS',
  AZ_SCOTTSDALE = 'AZ_SCOTTSDALE',
  AZ_PHOENIX = 'AZ_PHOENIX',
  UT_COTTONWOOD_HEIGHTS = 'UT_COTTONWOOD_HEIGHTS',
  UT_SALT_LAKE_CITY = 'UT_SALT_LAKE_CITY',
  UT_SALT_LAKE = 'UT_SALT_LAKE',
  UT_MIDVALE = 'UT_MIDVALE',
  WA_SEATTLE = 'WA_SEATTLE',
  CA_SAN_RAMON = 'CA_SAN_RAMON',
  CA_SAN_FRANCISCO = 'CA_SAN_FRANCISCO',
  CA_LOS_ANGELES = 'CA_LOS_ANGELES',
  CA_SAN_DIEGO = 'CA_SAN_DIEGO',
  OH_MIDDLEBURG_HEIGHTS = 'OH_MIDDLEBURG_HEIGHTS',
  OH_CLEVELAND = 'OH_CLEVELAND',
  MI_ANN_ARBOR = 'MI_ANN_ARBOR',
  IL_CHICAGO = 'IL_CHICAGO',
  MN_MINNEAPOLIS = 'MN_MINNEAPOLIS',
  MN_ST_PAUL = 'MN_ST_PAUL',
  CO_DENVER = 'CO_DENVER',
  LOMBARDIA_MILANO = 'LOMBARDIA_MILANO',
  KS_WESTWOOD = 'KS_WESTWOOD',
}
export const HUB_NAME_MAPPING: Record<EHubLocationAlias, string> = {
  MA_ANDOVER: 'Andover',
  NJ_TETERBORO: 'NY NJ',
  NJ_NEW_YORK: 'NY NJ',
  NC_DURHAM: 'Durham',
  GA_ATLANTA: 'Atlanta',
  GA_SANDY_SPRINGS: 'Atlanta',
  FL_TAMPA: 'Tampa',
  TX_HOUSTON: 'Houston',
  TX_DALLAS: 'Dallas',
  AZ_SCOTTSDALE: 'Phoenix',
  AZ_PHOENIX: 'Phoenix',
  UT_COTTONWOOD_HEIGHTS: 'Salt Lake',
  UT_SALT_LAKE_CITY: 'Salt Lake',
  UT_SALT_LAKE: 'Salt Lake',
  UT_MIDVALE: 'Salt Lake',
  WA_SEATTLE: 'Seattle',
  CA_SAN_RAMON: 'San Ramon',
  CA_SAN_FRANCISCO: 'San Ramon',
  CA_LOS_ANGELES: 'Los Angeles',
  CA_SAN_DIEGO: 'San Diego',
  OH_MIDDLEBURG_HEIGHTS: 'Cleveland',
  OH_CLEVELAND: 'Cleveland',
  MI_ANN_ARBOR: 'Ann Arbor',
  IL_CHICAGO: 'Chicago',
  MN_MINNEAPOLIS: 'Minneapolis',
  MN_ST_PAUL: 'Minneapolis',
  CO_DENVER: 'Denver',
  LOMBARDIA_MILANO: 'Milan',
  KS_WESTWOOD: 'Kansas',
};
